"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Roundabout.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Roundabout = function Roundabout(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "solid-icon",
    viewBox: "0 0 166.3 166.3"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M83.2 0C37.2 0 0 37.2 0 83.2s37.2 83.2 83.2 83.2 83.2-37.2 83.2-83.2S129.2 0 83.2 0zM23.7 98c-1.1-4.7-1.7-9.5-1.7-14.4 0-20 9.5-38.3 24.9-49.9H30.7v-11h37.8V60h-11V39.7C42.5 49 33 65.5 33 83.6c0 4.1.5 8 1.4 11.9L23.7 98zm60.9 44.1c-9.8 0-19.2-2.3-27.8-6.5l7 16.8-10.2 4.2L39 121.7l34.5-14.5 4.2 10.2-17.7 7.4c7.5 4 15.9 6.2 24.5 6.2 13.8 0 26.8-5.4 36.5-15.2l7.8 7.8c-11.8 11.9-27.5 18.5-44.2 18.5zm28.9-62.6L119 70l15.8 9.2c-1.9-22-17.5-40.5-39.3-45.7l2.6-10.7c24.7 5.9 42.9 25.9 47 50.3l7.1-12.2 9.6 5.6-18 30.7-30.3-17.7z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }));
};
exports.default = Roundabout;